import { createPortal } from "react-dom";

export default function Modal({
  open,
  onClose,
  children,
}) {
  if (!open) return null;

  return createPortal(
    <div
      className="
        fixed
        inset-0
        z-[9999]
        bg-black/40
        backdrop-blur-sm
        flex
        items-center
        justify-center
        p-4
      "
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="
          bg-white
          rounded-3xl
          shadow-2xl
          w-full
          max-w-2xl
          p-8
        "
      >
        {children}
      </div>
    </div>,
    document.getElementById("modalroot")
  );
}